<div class="leaderboard card">
    @if (isLoading()) {
        <div class="leaderboard__header card__header">
            <app-skeleton-card
                [showHeader]="true"
                [headerWidth]="'l'"
                [lines]="0"
            ></app-skeleton-card>
        </div>
        <div class="leaderboard__content">
            <div class="leaderboard__highlight">
                <app-skeleton-card
                    [showHeader]="false"
                    [lines]="2"
                    [lineWidths]="['xl', 'm']"
                ></app-skeleton-card>
            </div>
            <div>
                <app-skeleton-list [items]="5" [itemHeight]="50"></app-skeleton-list>
            </div>
        </div>
    } @else if (hasError()) {
        <div class="leaderboard__header card__header">
            <h2 class="leaderboard__title">{{ title }}</h2>
        </div>
        <div class="leaderboard__content leaderboard__content--error">
            <div class="leaderboard__error-message">{{ errorMessage }}</div>
        </div>
    } @else {
        <div class="leaderboard__header card__header">
            <h2 class="leaderboard__title">{{ title }}</h2>
            <div
                class="leaderboard__filter"
                appClickOutside
                (clickOutside)="isDropdownOpen() && isDropdownOpen.set(false)"
                (click)="toggleDropdown(); $event.stopPropagation()"
            >
                <button
                    type="button"
                    class="leaderboard__filter-button"
                    [class.leaderboard__filter-button--active]="isDropdownOpen()"
                >
                    {{ selectedLabel() }}
                    <img [src]="dropdownIcon" alt="Dropdown" class="leaderboard__filter-icon" />
                </button>
                @if (isDropdownOpen()) {
                    <div class="leaderboard__menu" (click)="$event.stopPropagation()">
                        @for (option of options; track option) {
                            <div
                                class="leaderboard__option"
                                [class.leaderboard__option--selected]="
                                    option.value === selectedType()
                                "
                                (click)="selectType(option.value); $event.stopPropagation()"
                            >
                                {{ option.label }}
                            </div>
                        }
                    </div>
                }
            </div>
        </div>

        <div class="leaderboard__content">
            <div class="leaderboard__highlight">
                <div class="leaderboard__rank leaderboard__rank--winner">
                    1<sup>{{ getOrdinalSuffix(1) }}</sup>
                </div>
                <div class="leaderboard__avatar-wrapper leaderboard__avatar-wrapper--large">
                    <img [src]="personIcon" alt="Person" class="leaderboard__avatar" />
                </div>
                <div class="leaderboard__winner-name">{{ topUser()?.name }}</div>
                <div class="leaderboard__winner-score">{{ topUser()?.score }}</div>
            </div>
            <ul class="leaderboard__list">
                @for (user of restUsers(); track user; let ind = $index) {
                    <li class="leaderboard__item">
                        <div class="leaderboard__rank">
                            {{ ind + 2 }}<sup>{{ getOrdinalSuffix(ind + 2) }}</sup>
                        </div>
                        <div class="leaderboard__user">
                            <div class="leaderboard__avatar-wrapper">
                                <img [src]="personIcon" alt="Person" class="leaderboard__avatar" />
                            </div>
                            <div class="leaderboard__name">{{ user.name }}</div>
                        </div>
                        <div class="leaderboard__score">{{ user.score }}</div>
                    </li>
                }
            </ul>
        </div>
    }
</div>
